// extracted by mini-css-extract-plugin
export default {"box":"file-xlsx_box__ntCVL","download":"file-xlsx_download__k6GRJ","icon":"file-xlsx_icon__378wd"};